// Labels say who a starter suits: how hard it is, how much schooling it takes to follow,
// how close to home it cuts, how much it splits a room and what it's about. Every starter
// has one value in each dimension. Ordered dimensions run from least to most.
//
// Kept apart from the catalogue so the browser can use them (the question queue moves
// people up through the levels) without loading every question.
export const STARTER_LABELS = [
  {
    id: "complexity",
    label: "Complexity",
    values: [
      { id: "simple", label: "Simple", description: "One clear idea anyone can weigh in on" },
      { id: "layered", label: "Layered", description: "Easy to ask, with more underneath than it seems" },
      { id: "complex", label: "Complex", description: "Abstract; rewards patience and careful thought" },
    ],
  },
  {
    id: "education",
    label: "Education level",
    // The earliest stage someone can follow it from, so filtering by a level includes the ones below.
    cumulative: true,
    values: [
      { id: "elementary", label: "Elementary", description: "Kids can follow it and join in" },
      { id: "middle", label: "Middle school", description: "Needs a little more experience of the world" },
      { id: "high", label: "High school", description: "Draws on ideas about society, faith or the self" },
      { id: "college", label: "College", description: "Helps to know some philosophy, science or history" },
    ],
  },
  {
    id: "weight",
    label: "Emotional weight",
    values: [
      { id: "light", label: "Light", description: "Thought-provoking, with little at stake personally" },
      { id: "moderate", label: "Moderate", description: "Touches people's own lives and choices" },
      { id: "heavy", label: "Heavy", description: "Grief, faith or family wounds — go gently" },
    ],
  },
  {
    id: "divisiveness",
    label: "Divisiveness",
    values: [
      { id: "common-ground", label: "Common ground", description: "People tend to agree more than they expect" },
      { id: "spirited", label: "Spirited", description: "Real disagreement, usually good-natured" },
      { id: "hot-button", label: "Hot-button", description: "Politics, religion or identity; views run deep" },
    ],
  },
  {
    id: "focus",
    label: "Focus",
    values: [
      { id: "personal", label: "Personal", description: "How you live your own life" },
      { id: "relationships", label: "Relationships", description: "How we treat the people close to us" },
      { id: "society", label: "Society", description: "How we live together" },
      { id: "abstract", label: "Abstract", description: "The nature of truth, mind and reality" },
    ],
  },
] as const;
export type StarterLabelDimension = (typeof STARTER_LABELS)[number];
export type StarterLabelId = StarterLabelDimension["id"];
export type StarterLabels = { [D in StarterLabelDimension as D["id"]]: D["values"][number]["id"] };
